//@flow
/* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */
/* eslint-disable camelcase */

const ImageSource = require('../../source/image_source');
const ajax = require("../../util/ajax");
const window = require("../../util/window");
const EXTENT = require('../../data/extent');
// const VertexArrayObject = require('../../render/vertex_array_object');
const rasterBoundsAttributes = require('../../data/raster_bounds_attributes');
const getType = require('../../style-spec/util/get_type');
const Json2texture = require('./json2texture');
const { LercDecode } = require('./lercdecode');
const { isByteType, isImgType } = require('./util');
const SegmentVector = require('../../data/segment');


type GeojsonMaskStatus = 'none' | 'loaded' | 'error' | 'loading';
class LercImageSource extends ImageSource {
    geojsonMaskStatus: GeojsonMaskStatus;
    constructor(id: string, options: ImageSourceSpecification | VideoSourceSpecification | CanvasSourceSpecification, dispatcher: Dispatcher, eventedParent: Evented) {
        super(id, options, dispatcher, eventedParent);
        this.headers = options.headers || [];
        this.geojsoMask = options['geojson-mask'] || false;
        this.geojsoMaskStatus = 'none';
        this.imageStatus = 'loading';
        this._decode = options.decode || LercDecode;
    }
    load() {
        // const floatTextures = gl.getExtension('OES_texture_float');
        // if (!floatTextures) {
        //     this.fire('error', {error: new Error('gl not support OES_texture_float')});
        //     return;
        // }
        this.fire('dataloading', { dataType: 'source' });
        this.loadGeojsonMask();
        const requestParameters = {
            url: this.options.url,
            headers: this.options.headers,
        };

        ajax.getArrayBuffer(requestParameters, done.bind(this));
        const callback = (err) => {
            if (err) {
                this.fire('error', err);
            }
            this.imageStatus = 'loaded';
            if (this.geojsoMaskStatus !== 'loading') {
                this._finishLoading();
            }
        };
        function done(err, img) {
            if (err) return this.fire('error', { error: err });
            const dataDecode = this._decode;

            if (dataDecode.verify && !dataDecode.verify(img)) {
                this.imageStatus = "errored";
                return callback({ error: 'tile data verify err' });
            }
            if (dataDecode.type === 'img') {
                dataDecode.decode(img, (lerc) => {
                    this.loadImgData2Texture(this, lerc, callback);
                });
            } else if (dataDecode.type === 'buffer') {
                dataDecode.decode(img, (lerc) => {
                    this.loadBufferData2Texture(this, lerc, callback);
                });
            }
            // dataDecode.decode(img, (lerc) => {
            //     if (!lerc) {
            //         return this.fire('error', 'tile data decode err');
            //     }

            //     // if (this.map._refreshExpiredTiles) tile.setExpiryData(img);
            //     // delete img.cacheControl;
            //     // delete img.expires;
            //     //è§£ælercæ°æ®

            //     this.image = lerc.data;
            //     this.image.width = lerc.width;
            //     this.image.height = lerc.height;
            //     this.imageStatus = 'loaded';
            //     if (this.geojsoMaskStatus !== 'loading') {
            //         this._finishLoading();
            //     }
            // });
        }
    }
    loadGeojsonMask() {
        const geojsoMask = this.geojsoMask;
        if (!geojsoMask) {
            this.geojsonMaskStatus = 'none';
        } else if (getType(geojsoMask) === 'string') {
            this.geojsoMaskStatus = 'loading';
            ajax.getJSON({
                url: this.geojsoMask
            }, (err, json) => {
                if (err) {
                    this.geojsoMaskStatus = 'error';
                    this.fire('error', { error: new TypeError('error json data') });
                    return;
                }
                this.geojson = json;
                this.geojsoMaskStatus = 'loaded';
                if (this.imageStatus === 'loaded') {
                    this._finishLoading();
                }
            });
        } else if (getType(geojsoMask) === 'object') {
            this.geojsoMaskStatus = 'loaded';
            this.geojson = this.geojsoMask;
        }
    }
    geojson2texture() {
        if (this.geojson) {
            this.geojsonTexture = new Json2texture(this.map.painter.context.gl, 256)
                .json2texture(this.geojson, this.coordinates);
        }

    }
    // setCoordinates(coordinates) {
    //     super.setCoordinates(coordinates);
    //     return this;
    // }
    _prepareOffsetMatrix(boundsArray) {
        // const [xMin,yMin,,,,Xmax]
        const xMin = boundsArray[0];
        const yMin = boundsArray[1];
        const xMax = boundsArray[4];
        const yMax = boundsArray[9];
        const xOffset = xMin / EXTENT;
        const yOffset = yMin / EXTENT;
        const xFactor = (xMax - xMin) / EXTENT;
        const yFactor = (yMax - yMin) / EXTENT;
        return new Float32Array([
            xFactor, 0, 0,
            0, yFactor, 0,
            xOffset, yOffset, 1
        ]);
    }
    prepare() {
        if (Object.keys(this.tiles).length === 0 || !this.texture) {
            return;
        }
        const context = this.map.painter.context;
        // const gl = context.gl;
        // const image = this.lerc;

        if (!this.boundsBuffer) {
            this.boundsBuffer = context.createVertexBuffer(this._boundsArray, rasterBoundsAttributes.members);
        }
        if (!this.boundsSegments) {
            this.boundsSegments = SegmentVector.simpleSegment(0, 0, 4, 2);
        }
        if (!this.offsetMatrix) {
            this.offsetMatrix = this._prepareOffsetMatrix(this._boundsArray.int16);
        }
        if (!this.geojsonTexture && this.geojsoMaskStatus !== 'none') {
            this.geojson2texture();
        }
        if (!this.textureLoaded) {
            // const floatTextures = gl.getExtension('OES_texture_float');
            // if (!floatTextures) {
            //     this.fire('error', { error: new Error('gl not support OES_texture_float') });
            //     return;
            // }
            this.textureLoaded = true;
            // this.texture = gl.createTexture();
            // gl.bindTexture(gl.TEXTURE_2D, this.texture);
            // gl.texImage2D(gl.TEXTURE_2D, 0, gl.LUMINANCE, image.width, image.height, 0, gl.LUMINANCE, gl.FLOAT, new Float32Array(image));

            // gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            // gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
            // gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
            // gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
            // if (this.map.painter.extTextureFilterAnisotropic) {
            //     gl.texParameterf(gl.TEXTURE_2D, this.map.painter.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, this.map.painter.extTextureFilterAnisotropicMax);
            // }
            // } else {
            //     gl.bindTexture(gl.TEXTURE_2D, this.texture);
            //     gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, gl.LUMINANCE, gl.FLOAT, image);
            //     // gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, gl.RGBA, gl.UNSIGNED_BYTE, image);
        }

        for (const w in this.tiles) {
            const tile = this.tiles[w];
            if (tile.state !== 'loaded') {
                tile.state = 'loaded';
                tile.texture = this.texture;
            }
        }
    }
    loadBufferData2Texture(tile, lerc, callback) {
        const gl = this.map.painter.context.gl;
        tile.lerc = lerc.data;
        const { glenum, dataType, ArrayType = "Float32Array", width = 256, height = 256, border = 0, data } = lerc;

        if (!tile.lerc) {
            tile.state = "errored";
            return callback("tile data decode err");
        }
        if(gl.isWebgl2){
            tile.texture = gl.createTexture();
            gl.bindTexture(gl.TEXTURE_2D, tile.texture);
            if (isByteType(dataType)) {
                this.map.painter.context.pixelStoreUnpack.set(1);
            }
            if(ArrayType == "Float32Array"){
                gl.texImage2D(
                    gl.TEXTURE_2D,
                    0,
                    gl.R32F,
                    width,
                    height,
                    border,
                    gl.RED,
                    gl[dataType],
                    new window[ArrayType](data),
                );
            }else{
                gl.texImage2D(
                    gl.TEXTURE_2D,
                    0,
                    gl[glenum],
                    width,
                    height,
                    border,
                    gl[glenum],
                    gl[dataType],
                    new window[ArrayType](data),
                );
            }
        }else{
            const floatTextures = gl.getExtension("OES_texture_float");
            if (!floatTextures) {
                return callback("no floating point texture support");
            }
            tile.texture = gl.createTexture();
            gl.bindTexture(gl.TEXTURE_2D, tile.texture);
            if (isByteType(dataType)) {
                this.map.painter.context.pixelStoreUnpack.set(1);
            }
            gl.texImage2D(
                gl.TEXTURE_2D,
                0,
                gl[glenum],
                width,
                height,
                border,
                gl[glenum],
                gl[dataType],
                new window[ArrayType](data),
            );
        }
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        if (this.map.painter.extTextureFilterAnisotropic) {
            gl.texParameterf(
                gl.TEXTURE_2D,
                this.map.painter.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT,
                this.map.painter.extTextureFilterAnisotropicMax,
            );
        }
        tile.texture.size = lerc.width;
        if(gl.isWebgl2){
        }else{
            gl.generateMipmap(gl.TEXTURE_2D);
        }
        tile.state = "loaded";
        callback(null);
    }
    loadImgData2Texture(tile, lerc, callback) {
        const gl = this.map.painter.context.gl;
        tile.image = lerc.data;
        const {
            glenum,
            dataType,
            data,
        } = lerc;
        if (!isImgType(data)) {
            tile.state = "errored";
            return callback(`layer.${this.id}: data is not a img type. It should be one of HTMLImageElement ,HTMLCanvasElement, HTMLVideoElement, ImageData`);
        }
        tile.texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, tile.texture);
        if (isByteType(dataType)) {
            this.map.painter.context.pixelStoreUnpack.set(1);
        }
        gl.texImage2D(gl.TEXTURE_2D, 0, gl[glenum], gl[glenum], gl[dataType], data);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        if (this.map.painter.extTextureFilterAnisotropic) {
            gl.texParameterf(gl.TEXTURE_2D, this.map.painter.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, this.map.painter.extTextureFilterAnisotropicMax);
        }
        tile.texture.size = lerc.width;
        gl.generateMipmap(gl.TEXTURE_2D);
        tile.state = "loaded";
        callback(null);
    }
    serialize() {
        return {
            type: 'lerc-image',
            urls: this.url,
            coordinates: this.coordinates
        };
    }
    verifyLerc(data, options) {
        options = options || {};
        const inputOffset = options.inputOffset || 0;
        const fileIdView = new Uint8Array(data, inputOffset, 10);
        const fileIdentifierString = String.fromCharCode.apply(null, fileIdView);
        if (
            fileIdentifierString.trim() === "CntZImage" ||
            fileIdentifierString.substring(0, 5) === "Lerc2"
        )
            return true;
        else return false;
    }
}

module.exports = LercImageSource;
